<template>
  <ul class="pg-table-radio flex wrap">
    <template v-for="(d,i) in list">
      <li class="flex mr10 aic" :key="i" v-if="!d.id">
        <div class="icon mr5">
          <img :src="getSrc(d.value)" width="20" height="20" alt="">
        </div>
        <div>{{ d.label }}</div>
      </li>
      <li class="flex aic mr10" :key="'e'+i" v-if="d.id">
        <div class="icon mr5">
          <img :src="getSrc(d.value)" width="20" height="20" alt="">
        </div>
        <div>{{ d.label }}{{ d.pre }}<input type="text" :style="{width:d.width}" readonly :value="d.data"/>{{ d.suf }}
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: "pg-table-checkbox",
  props: {
    value: [String, Number, Array],
    extra: {
      type: Array, default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    list() {
      const {data = []} = this;
      return data.map((r, i) => {
        if (typeof r === 'string') return {
          label: r,
          value: i
        }
        return {
          ...r,
          value: i
        }
      })
    }
  },
  methods: {
    getSrc(value) {
      return this.inValue(value) ? require('../../../../public/img/方形选中-fill.png') : require('../../../../public/img/方形未选中.png');
    },
    inValue(val) {
      if (Array.isArray(this.value))
        for (const valElement of this.value) {
          if (valElement == val) return true;
        }
      return false;
    }
  },
}
</script>

<style scoped lang="scss">
.pg-table-radio {
  li {
    height: 28px
  }
}

.icon {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  background-image: url('../../../../public/img/方形未选中.png');

  &.curr {
    background-image: url("../../../../public/img/方形选中-fill.png");
  }
}

input {
  text-align: center;
  width: 50px;
  font-size: 14px;
  border: 0px none;
  outline: none;
  border-bottom: 1px solid #333;
}
</style>